/**
 * API Client
 * Base fetch wrapper with authentication and error handling
 */

export const API_BASE_URL = import.meta.env.VITE_APP_SERVER_URL || 'http://localhost:8000';
export const AUTH_TOKEN = 'quran-token';

interface FetchOptions extends RequestInit {
  requiresAuth?: boolean;
}

/**
 * Base fetch wrapper with authentication handling
 */
export async function fetchAPI<T = any>(
  endpoint: string,
  options: FetchOptions = {}
): Promise<T> {
  const { requiresAuth = true, ...fetchOptions } = options;

  const headers: HeadersInit = {
    ...fetchOptions.headers,
  };

  // Only set application/json if not already set and body is not FormData
  if (!headers['Content-Type' as keyof HeadersInit] && !(fetchOptions.body instanceof FormData)) {
    (headers as any)['Content-Type'] = 'application/json';
  }

  // Add authentication token if required
  if (requiresAuth) {
    const token = localStorage.getItem(AUTH_TOKEN);
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
  }

  const url = endpoint.startsWith('http') ? endpoint : `${API_BASE_URL}${endpoint}`;

  const response = await fetch(url, {
    ...fetchOptions,
    headers,
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    const errorMessage = errorData.detail || errorData.message || response.statusText;
    throw new Error(errorMessage);
  }

  return response.json();
}
